import React, { useMemo } from "react"

import { EmptyStateBase, EmptyStateBaseProps } from "../empty-state-base"

import DefaultImageLarge from "./assets/large.svg"
import DefaultImageMedium from "./assets/medium.svg"
import { EmptyStateImageSize } from "./enumeration"
import { EmptyStateImageContainer, StyledImg } from "./styles"

export type EmptyStateImageProps = EmptyStateBaseProps & {
  url?: string
  size?: EmptyStateImageSize
  isDefaultImage?: boolean
}

export const EmptyStateImage: React.FC<EmptyStateImageProps> = ({
  url,
  size = EmptyStateImageSize.Medium,
  isDefaultImage,
  headline,
  subtitle,
  ctaButtonProps,
}) => {
  const image = useMemo(() => {
    if (!isDefaultImage && !url) {
      return null
    }

    return (
      <EmptyStateImageContainer size={size}>
        {(isDefaultImage &&
          (size === EmptyStateImageSize.Medium ? (
            <DefaultImageMedium />
          ) : (
            <DefaultImageLarge />
          ))) || <StyledImg src={url} alt={headline} />}
      </EmptyStateImageContainer>
    )
  }, [url, size, isDefaultImage])

  return (
    <EmptyStateBase
      headline={headline}
      subtitle={subtitle}
      ctaButtonProps={ctaButtonProps}
    >
      {image}
    </EmptyStateBase>
  )
}

export { EmptyStateImageSize } from "./enumeration"
